import { ChangeEventHandler } from 'react'
import { TextField, InputAdornment, useMediaQuery, useTheme } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

import useStyles from './styles'
import { useTranslation } from 'react-i18next'

interface ISearchBarProps {
  search?: string
  handleSearchChange: ChangeEventHandler<HTMLInputElement>
  inputPlaceholder?: string
  autoFocus?: boolean
}

const SearchBar = ({
  search,
  handleSearchChange,
  inputPlaceholder,
  autoFocus,
}: ISearchBarProps) => {
  const [t] = useTranslation()
  const theme = useTheme()
  const classes = useStyles()
  const isDesktop = useMediaQuery(theme.breakpoints.up('laptop_l'))

  return (
    <TextField
      autoComplete="off"
      className={classes.searchField}
      autoFocus={autoFocus}
      id="search"
      name="search"
      value={search}
      type="text"
      onChange={handleSearchChange}
      size="small"
      placeholder={inputPlaceholder || t('search-input-placeholder.v')}
      InputProps={{
        className: classes.searchFieldInput,
        startAdornment: isDesktop && (
          <InputAdornment position="start">
            <SearchIcon sx={{ width: 20, height: 20 }} />
          </InputAdornment>
        ),
        endAdornment: !isDesktop && (
          <InputAdornment position="end">
            <SearchIcon sx={{ width: 20, height: 20 }} />
          </InputAdornment>
        ),
      }}
    />
  )
}

export { SearchBar }
